function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import { ComponentBootstrap, withReactBootstrap } from '@demant/react-bootstrap';
import flexSpotSchema from '@demant/react-bootstrap/lib/schemas/flex-spot-json';
var CustomBannerReactComponent = function CustomBannerReactComponent(_ref) {
  var settings = _ref.settings,
    component = _ref.component,
    isDesktop = _ref.isDesktop,
    pageScrollOffset = _ref.pageScrollOffset;
  var element = settings.elements[0];
  var componentData = {
    image: element['image'] ? element['image'].image : null,
    header: element['header'] ? element['header'].html.html : null,
    description: element['description'] ? element['description'].html.html : null,
    link: element.link ? element.link.link : null
  };
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    scrollPos = _useState2[0],
    setScrollPos = _useState2[1];
  useEffect(function () {
    checkStorage();
    hideContentOnMobile();
  }, []);
  useEffect(function () {
    handleOnScroll();
  }, [pageScrollOffset]);
  var checkStorage = function checkStorage() {
    if (settings && sessionStorage.getItem('popUpClose') === null) {
      setTimeout(function () {
        component.classList.add('active-banner');
      }, 2000);
    }
  };
  var hideContentOnMobile = function hideContentOnMobile() {
    !isDesktop ? component.classList.add('hide-content') : null;
  };
  var handleOnScroll = function handleOnScroll() {
    var HOLD_UP = 150;
    if (Math.abs(scrollPos - pageScrollOffset) <= HOLD_UP) {
      return;
    }
    if (!isDesktop) {
      component.classList.add('hide-content');
    } else {
      if (pageScrollOffset > scrollPos) {
        component.classList.add('hide-content');
      } else {
        component.classList.remove('hide-content');
      }
    }
    setScrollPos(pageScrollOffset);
  };
  var closeHandler = function closeHandler() {
    sessionStorage.setItem('popUpClose', 'true');
    component.classList.remove('active-banner');
  };
  var closeHandlerOnKeyDown = function closeHandlerOnKeyDown(e) {
    if (e.key === 'Enter') {
      closeHandler();
    }
  };
  var showContentOnClick = function showContentOnClick() {
    component.classList.remove('hide-content');
  };
  var showContentOnKeyDown = function showContentOnKeyDown(e) {
    if (e.key === 'Enter') {
      showContentOnClick();
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, componentData.header && /*#__PURE__*/React.createElement("div", {
    className: 'flex-banner',
    onClick: showContentOnClick,
    onKeyDown: function onKeyDown(e) {
      return showContentOnKeyDown(e);
    },
    tabIndex: "0",
    role: "link"
  }, componentData.image.src && /*#__PURE__*/React.createElement("div", {
    className: "flex-banner__image"
  }, /*#__PURE__*/React.createElement("img", {
    src: componentData.image.src,
    alt: componentData.image.alt
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex-banner__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-banner__content__text"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-banner__content__header",
    dangerouslySetInnerHTML: {
      __html: componentData.header
    }
  }), componentData.description && /*#__PURE__*/React.createElement("div", {
    className: "flex-banner__content__description",
    dangerouslySetInnerHTML: {
      __html: componentData.description
    }
  })), componentData.link && /*#__PURE__*/React.createElement("div", {
    className: "flex-banner__content__button",
    role: "button"
  }, /*#__PURE__*/React.createElement("a", {
    href: componentData.link.href,
    className: "like-button popup-button"
  }, componentData.link.content))), /*#__PURE__*/React.createElement("div", {
    className: "flex-banner__close lightbox-close",
    onClick: closeHandler,
    onKeyDown: function onKeyDown(e) {
      return closeHandlerOnKeyDown(e);
    },
    role: "button",
    tabIndex: "0"
  })));
};
var c = new ComponentBootstrap('.flex-spot.popup-banner');
c.schemaData = flexSpotSchema;
c.reactApp = withReactBootstrap(CustomBannerReactComponent);
setTimeout(function () {
  return c.run();
}, 0);